import { ProductUpdateValuesType } from "../module/add-product/types";
import { APIResponseType, createThunkCase } from "@/redux/helper/thunk";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { merge } from "lodash";
import { thunks } from "./thunk";

interface APTStateType {
  productsList: APIResponseType;
  productDetails: APIResponseType;
}

const APIState: APTStateType = {
  productsList: {
    data: null,
    loading: false,
    meta: null,
  },
  productDetails: {
    data: null,
    loading: false,
    meta: null,
  },
};

interface stateType extends APTStateType {
  searchValue: string;
  currentPage: string;
}

const initialState = {
  searchValue: "",
  currentPage: "1",
  ...APIState,
} satisfies stateType as stateType;

export const slice = createSlice({
  name: "user_products",
  initialState,
  reducers: {
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<string>) => {
      state.currentPage = action.payload;
    },
    setProductDetails: (
      state,
      action: PayloadAction<ProductUpdateValuesType | null>
    ) => {
      if (action?.payload) {
        state.productDetails.data = merge(
          {},
          state.productDetails.data,
          action.payload
        );
      } else {
        state.productDetails = { ...initialState.productDetails };
      }
    },
  },
  extraReducers: (builder) => {
    Object.entries(thunks).forEach(([_, thunk]) => {
      createThunkCase(builder, thunk, APIState);
    });
  },
});

export const Actions = slice.actions;
export default slice.reducer;
